import React, { useMemo } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import StatusCard from './StatusCard';
import { useDashboardStore } from '../../../stores/dashboard-store';
import { useLanguage } from '../../../contexts/LanguageContext';
import { OutstandingIcon, UnsellableItemsIcon } from '../../../components/icons/DashboardIcons';

const ProcuredSection: React.FC = () => {
  const { stats } = useDashboardStore();
  const { t } = useLanguage();

  // Remove the fetchStats call from individual components
  // The main dashboard page handles fetching stats

  const procuredCards = useMemo(() => [
    {
      title: t('dashboard.procuredItems'),
      value: (stats?.status_counts?.['procured-items'] || 0).toString(),
      change: '+8%',
      changeType: 'increase' as const,
      icon: OutstandingIcon,
      color: 'purple',
      navigateTo: '/orders?tab=procured_items'
    },
    {
      title: t('dashboard.unsellableItems'),
      value: (stats?.status_counts?.['unsettled-items'] || 0).toString(),
      change: '+50%',
      changeType: 'increase' as const,
      icon: UnsellableItemsIcon,
      color: 'red',
      navigateTo: '/orders?tab=unsettled_items'
    }
  ], [stats, t]);

  return (
    <div className="rounded-lg bg-[#F1F1F4] p-3 md:p-4">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-[35px] font-medium leading-none text-[#24304F]">{t('dashboard.procured')}</h2>
        <button className="inline-flex items-center gap-1.5 rounded-md bg-[#DFE3EC] px-3 py-1.5 text-[13px] font-medium text-[#5D6680]">
          <SlidersHorizontal size={14} />
          {t('common.week')}
        </button>
      </div>

      <div className="space-y-3">
        {procuredCards.map((card, index) => (
          <StatusCard
            key={index}
            card={card}
          />
        ))}
      </div>
    </div>
  );
};

export default ProcuredSection;